import { call, put, select, takeEvery } from 'redux-saga/effects';
import { Brand, Group } from 'sections/client-management/entities';
import {
  Actions as BrandActions,
  client as BrandClient,
  Selectors as BrandSelectors,
} from 'sections/client-management/services/brands';
import {
  Actions as GroupActions,
  client as GroupClient,
  Selectors as GroupSelectors,
} from 'sections/client-management/services/groups';
import { Actions as SiteActions, Selectors as SiteSelectors } from 'sections/client-management/services/sites';
import { EntityWithId, IClient } from 'services/genericAPIGatewayService';
import { NEW_BRAND_ID, NEW_GROUP_ID } from '../../ui/pages/creation-wizard/creation-pages/utils/constants';

enum Types {
  Create = 'CREATION_WIZARD:CREATE',
}

export interface Action {
  type: Types.Create;
  payload: ActionPayload;
}

export interface ActionPayload {
  groupId: string;
  brandId: string;
  siteIds: string[];
}

export const Actions = {
  create: (groupId: string, brandId: string, siteIds: string[]): Action => ({
    type: Types.Create,
    payload: {
      groupId,
      brandId,
      siteIds,
    },
  }),
};

/**
  @deprecated - https://github.com/SaleCycle/my-salecycle-com#legacy-code 
*/
export function* createSaga(payload: ActionPayload, groupClient: IClient<Group>, brandClient: IClient<Brand>) {
  let groupId = payload.groupId;
  if (groupId === NEW_GROUP_ID) {
    yield put(GroupActions.startCreate(groupId));

    const group = yield select(GroupSelectors.getUpdatedEntity, groupId);
    try {
      const savedGroup: EntityWithId<Group> = yield call([groupClient, 'post'], `/groups`, group);
      yield put(GroupActions.completeCreate(groupId, savedGroup));
      groupId = savedGroup.id;
    } catch (error) {
      return yield put(GroupActions.failCreate(groupId, (error as Error).message));
    }
  }

  let brandId = payload.brandId;
  if (brandId === NEW_BRAND_ID) {
    yield put(BrandActions.startCreate(brandId));

    const brand = yield select(BrandSelectors.getUpdatedEntity, brandId);
    try {
      const savedBrand: EntityWithId<Brand> = yield call([brandClient, 'post'], `/brands`, {
        ...brand,
        groupId,
      });
      yield put(BrandActions.completeCreate(brandId, savedBrand));
      brandId = savedBrand.id;
    } catch (error) {
      return yield put(BrandActions.failCreate(brandId, (error as Error).message));
    }
  }

  for (const id of payload.siteIds) {
    const site = yield select(SiteSelectors.getUpdatedEntity, id);
    yield put(SiteActions.requestCreate(id, { ...site, brandId }));
  }
}

/**
  @deprecated - https://github.com/SaleCycle/my-salecycle-com#legacy-code 
*/
export function* wizardCreationListener() {
  yield takeEvery(Types.Create, (action: Action) => createSaga(action.payload, GroupClient, BrandClient));
}
